export default {
  lang: "English",
  //general
  MEA: "Metropolitan Electricity Authority",
  MEAtitle: "MEA",
  Name: "Name",
  Lastname: "Lastname",
  Email: "Email",
  Tel: "Tel",
  Subject: "Subject",
  Company: "Company",
  Website: "Website",
  Requirement: "Requirement for your business",
  Signout: "Sign out",
  Cancel: "Cancel",
  TermPrivacy: "Term Privacy",
  Terms: "Terms",
  Privacy: "Privacy",
  PrivacyPolicy: "Privacy Policy",
  District: "District",
  Subdistrict: "Subdistrict",
  City: "City",
  Country: "Country",
  Zipcode: "Zip code",
  Password: "Password",
  Accesstoken: "API Key",
  Seachforname:
    "Search for a name of user and enter details to view the report.",
  Individual: "Individual usage summary",
  SigninMEA: "Sign in with MEA smart office",
  And: "and",
  BySignin: "By sign in, you agree to",
  ConfirmPassword: "Confirm password",
  Next: "Next",
  Account: "Account",
  Back: "Back",
  Finish: "Finish",
  SaveChange: "Save change",
  UserProfile: "User Profile",
  APIConsole: "API Console",
  January: "January",
  February: "February",
  March: "March",
  April: "April",
  May: "May",
  June: "June",
  July: "July",
  August: "August",
  September: "Sebtember",
  October: "October",
  November: "November",
  December: "December",
  Delete: "Delete",
  Update: "Update",
  Save: "Save",
  NoPermission: "No permission",
  onSave: "Saving changes",
  Contract: "Contract",
  No: "No.",
  Filter: "Filter",
  Rows: "Rows",
  Date: "Date",
  Time: "Time",
  FirstPage: "First page",
  PreviousPage: "Previous page",
  NextPage: "Next page",
  LastPage: "Last page",
  YouHave: "You have",
  ViewAll: "View all",
  Pendingtask: "pending task",
  Clear: "Clear",
  Edit: "Edit",
  LoginSuccessfully: "Sign in successfully",
  LogingIn: "Logging to the internal",
  LogoutSuccessfully: "Sign out successfully",
  SignupSuccess: "Please check your email to verify your account.",
  Norecord: "No records to display",
  IncorrectEmail: "Email or password is incorrect",
  AddressMEA:
    "Metropolitan Electricity Authority, Yannawa Charoen Krung Road, Yannawa, Bangkok, 10120",
  NotFound: "Not found",
  MonthlyUsage: "Monthly usage",
  Error: "Error",
  Success: "Success",
  Activate: "Activated",
  //subhome
  MEAsubtitle:
    "Develop Business, Creating Value using Electrical Data and Map System",
  SubtitlesExclusiveService: "",
  SubtitlesAboutMEA:
    "For more than 20 years, The Metropolitan Electricity Authority has developed a Electricial geospatial database include high resolution landbase map And electrical system map in area of responsibility; Bangkok, Nonthaburi and Samut Prakan. MEA has provided map service not only internal departments but also external agencies. This concept has led to expanding the scope of providing map data to the public and other agencies. This is the starting point for MEA - Map Service API to provide opportunities for people to access to electrical mapping services.",
  SubtitlesOurAPI: "",
  SubtitlesDataService:
    "Data Service, providing landbase and electirc data with APIs",
  SubtitlesMapService:
    "Map Service, providing electrical map witn Vector Tiles and Raster Tiles.",
  SubtitlesHowtouseAPI: "",
  SubtitlesGetStartNow: "",
  SubtitlesFooter: "Electrical Map Service System",

  //subservice
  SubtitlesService: "",
  Subtitles2Service: "",
  SubtitlesDataServiceHave: "",
  SubtitlesMapServiceHave: "",
  SubtitlesPremiumAPI: "",
  SubtitlesPremiumAPI1: "",
  SubtitlesPremiumAPI2: "",
  SubtitlesPremiumAPI3: "",
  SubtitlesDataAPI: "",
  SubtitlesElectricDataAPI: "",
  SubtitlesLandbaseMapAPI: "",

  //subpricing
  SubtitlesPricing: "",
  SubtitlesAllPlan: "",
  SubtitlesService1: "",
  SubtitlesService2: "",
  SubtitlesService3: "",
  SubtitlesEnterprise: "",

  //subdoc
  SubtitlesDocument: "",
  SubtitlesIntroduction: "",
  SubtitlesAccesstoken: "",
  SubtitlesAPIversioning: "",
  SubtitlesRateLimits: "",

  //subpsupport
  SubtitlesSupport: "",
  SubtitlesDoyouhavequestion: "",
  SubtitlesContactUs: "",
  SubtitlesFaq: "",

  //subwelcome
  SubtitlesWelcome: "",
  SubtitlesYoucanaccessAPI: "You can access API are include",
  SubtitlesAPIusage: "",
  SubtitlesSummary: "",
  SubtitlesDataAPIservice: "",

  //appbar
  HOME: "Home",
  SERVICE: "Service",
  Service1: "Data Service",
  Service2: "Map Service",
  PRICING: "Pricing",
  DOCUMENT: "Document",
  SUPPORT: "Support",
  Signin: "SIGN IN",
  Register: "Register",

  //home
  Getstart: "GET START",
  Ourexclusiveservice: "Our Exclusive Service",
  Service: "Service",
  About: "About",
  Contactus: "Contact Us",
  OurApi: "Our API",
  DataService: "Data Service",
  MapService: "Map Service",
  Address: "Address",
  Howtouse: "How to use",
  API: "API",
  GetStartNow: "Get Start Now",
  CreateAccount: "Create Account",
  Legal: "Legal",
  Chooseaplan: "Create API Key",
  CreateProject: "Top Up Your Account",
  Get: "Use API",

  //footer
  TermCondition: "Term & Condition",

  //service
  Premium: "Premium",

  //pricing
  Freetier: "Free Tier",
  Payasyougo: "Pay as you go",
  Request: "Request",
  Freeplan: "Get started for free",
  Orderplan: "Get started",
  Contactplan: "Contact",
  Contact: "Contact",
  AllPlanareInclude: "All Plan are Include",
  Enterprise: "Enterprise",
  SendMessage: "Send Message",

  //document
  Introduction: "Introduction",
  Vector: "Vector",
  Raster: "Raster",
  Parameter: "Parameter",
  Example: "Example",
  Value: "Value",
  Description: "Description",
  Code: "Code",
  Status: "Status",
  Result: "Result",
  Tag: "Tag",
  Src: "Src",
  lat: "Lat",
  Lon: "Lon",
  LandmarkPoint: "Landmark points",
  DistrictPoly: "District poly",
  LandmarkLine: "Landmark line",
  CenterLine: "Center line",
  RoadEdge: "Road edge",
  Building: "Building",
  BuildingLine: "Building line",
  Hydrology: "Hydrology",
  Capacitor: "Capacitor",
  cctv: "cctv",
  DuctBank: "Duct bank",
  FiberOpticCable: "FiberOpticCable",
  Fuse: "Fuse",
  Ground: "Ground",
  GroundMeter: "Group meter",
  HighTensionMeter: "High tension meters",
  InlineEquipment: "Inline equipment",
  LightningArrestor: "Lightning arrestor",
  LowVoltageMeter: "Low voltage meter",
  Manhole: "Manhole",
  Meterline: "Meter line",
  Meterlink: "Meter link",
  OverheadHighVoltageConductor: "Overhead high voltage conductor",
  OverheadLowVoltageConductor: "Overhead low voltage conductor",
  OverheadLowVoltageConductorUnder:
    "Overhead low voltage conductor under building",
  OverheadMediumVoltageConductor: "Overhead medium voltage conductor",
  OverheadStreetlightVoltageConductor: "Overhead streetlight voltage conductor",
  Pole: "Pole",
  SpanGuy: "Span guy",
  Splice: "Splice",
  Streetlight: "Streetlight",
  StreetlightControl: "Streetlight control",
  Switche: "Switche",
  Transformer: "Transformer",
  UndergroundHighVoltageConductor: "Underground high voltage conductor",
  UndergroundLowVoltageConductor: "Underground low voltage conductor",
  UndergroundMediumVoltageConductor: "Underground medium voltage conductor",
  UndergroundStreetlightVoltageConductor:
    "Underground streetlight voltage conductor",
  Circuitbreaker: "Circuit breaker",
  Streetlightinlineequipment: "Streetlight inline equipment",
  Riser: "Cable riser pole",
  SubstationTransformer: "Substation transformer",
  Switchgear: "Switchgear",

  LandBaseDataAPI: "Landbase Data API",
  ElectricDataAPI: "Electric Data API",
  LandBaseAPI: "Landbase map API",
  ElectricAPI: "Electric map API",
  RateLimits: "Rate limits",
  ResponseMessages: "Response messages",
  Versioning: "versioning",
  Howto1: "1. Press the Authorize button to enter the API Key.",
  Howto2: '2. Select a endpoint, e.g. "Building".',
  Howto3: "3. Press the Try it out button to try out the API.",
  Howto4: "4. Customize the parameters according to the desired results.",
  Howto5: "5. Press the Execute button to view the results.",
  Badrequest: "Bad Request",
  Unauthorized: "Unauthorized",
  Forbidden: "Forbidden",
  Proxy: "Proxy Authentication Required",
  BadGateway: "Bad Gateway",
  GatewayTimeout: "Gateway Timeout",
  FiberOpticSystem: "Electrical System Fiber Optic",
  PublicSystem: "Electrical System Fiber Optic",
  OnGroundSystem: "Electrical System On Ground",
  UndergroundSystem: "Electrical System Underground",
  Landbase: "Landbase",
  Electric: "Electric",
  SubtitlesDescription:
    "Run by changing the Endpoint Name from “landbases” to any other Endpoint Name as required.",
  DescriptionService: "Execution of Map Service, other layers.",
  UsingSCS: "Using SCS map iframe",
  UsageParameter: "Usage Parameter",
  YourAPI: "Your API-key",
  Qparam:
    "The map center coordinate to display, for example, q = 100.554894,13.721237 If the default parameter is omitted, it will be the user's current location.",
  Zparam:
    "The zoom level if the parameter is omitted. The default value is zoom level 10.",
  Typeparam:
    "The usage type is indicated private and public if the parameter is omitted. The default is public.",
  Mtparam:
    "Base map format There are two types of images: satellite images and vectortile. The default is vectortile.",
  SCSExample: "SCS Map iframe Example",
  InitDataParam:
    "'true' to allow the system to return data upon first activation.",

  //support
  Doyouhaveanyquestion: "Do you have any question",
  Question: "Question",
  Phone: "Phone",
  Detail: "Detail",
  Submit: "Submit",
  Getintouch: "For more information or Report a problem",

  //admin
  Dashboard: "Dashboard",
  User: "User",
  UserName: "User name",
  Users: "Users",
  LimitUsage: "Limit Usage",
  Report: "Report",
  ApiRequest: "Requests",
  ApiKey: "API Key",
  TotalBalance: "Total Credit (THB)",
  Customer: "Customer",
  TimePeriod: "Time Period",
  From: "From",
  To: "To",
  Lastweek: "Last week",
  Last2week: "Last 2 weeks",
  Lastmonth: "Last month",
  Last3month: "Last 3 month",
  Last6month: "Last 6 month",
  Lastyear: "Last year",
  CustomPeriod: "Custom period",
  Moredetail: "More detail",
  Income: "Income",
  Bath: "Bath",
  Organization: "Organization",
  Type: "Type",
  CreateUser: "Create user",
  UserType: "User type",
  SearchUser: "Search User",
  Selectkeyname: "Select key name",
  SelectMonth: "Select month",
  SelectPeriod: "Select period",
  Selectyear: "Select year",
  Allmonth: "All month",
  Today: "Today",
  Customperiod: "Custom period",
  GenApiSuccess: "Create API key successfully",
  DeleteApiSuccess: "Delete API key successfully",
  UpdateApiSuccess: "Update API key successfully",
  APIcopied: "API key has been copied.",
  Times: "Times",
  Size: "Size",
  KB: "KB",

  // Status: "Status",
  Key: "Key",
  Month: "Month",
  Year: "Year",
  Layer: "Layer",
  Export: "Export",
  Seemore: "See more",

  //user
  Welcome: "Welcome",
  APIUsage: "API Usage",
  Summary: "Summary",
  Payment: "Payment",
  Period: "Period",
  Generate: "Generate",
  CreateAt: "Last created on",
  LastUpdate: "Last Update on",
  Createkeyname: "Create key name",
  Cost: "Cost",
  Apply: "Apply",
  Total: "Total",
  THB: "THB",
  Invoice: "Invoice",
  Monthlyexpendituresummary: "Monthly expenditure summary",
  PersonalInfo: "Personal Info",
  BillingInfo: "Billing Info",
  Start: "Start",
  End: "End",
  Addusersuccess: "Add user successfully",
  Updateusersuccess: "Update user successfully",
  Deleteusersuccess: "Delete user successfully",
  OldPassword: "Old Password",
  NewPassword: "New Password",
  EnableUser: "User enabled successfully",
  DisableUser: "User disabled successfully",
  CreateKeyName: "",
  For: "For",
  ChangePassword: "Change Password",
  Tax: "Tax ID",
  Add: "Add",
  OK: "OK",
  AddCredit: "Add Credit",
  YourTotalCredits: "Your total credits",
  InsertCredit: "Insert Credit",
  Amount: "Amount",
  AllType: "All Type",
  Keyname: "Key name",
  ApplicationRestriction: "Application Restriction",
  None: "None",
  AppResDetail:
    "An application restriction controls which websites, IP address, or applications can use your API key. You can set one application restriction per key.",
  HTTPReferrers: "HTTP Referrers",
  IPaddress: "IP address",
  Web: "Web",
  Server: "Server",
  etc: "etc.",
  Websiterestrictions: "Website restrictions",
  Updatekey: "Update API key",
  Deletekey: "Delete API key",
  EnableAPI: "Enable API Key",
  Restrictusage: "Restrict key usage requests to the specified websites.",
  AcceptrequestIP: "Accept requests from these server IP addresses",
  SpecifiedIP:
    "Specify one IPv4 IPv6 or a subnet using CIDR notation (e.g.192.168.0.0/22). Examples :192.168.0.1,172.16.0.0 //12,2001:db8:1 or db8:/64",
  Confirmkeydelete: "Confirm key name to continue.",
  DialogAddCredit: "You want to add credit",
  PleaseOk: ' Please click "OK" to confirm the amount you top up.',
  DeleteUser: "Delete user",
  ConfirmNameUser: "Confirm user name - lastname to continue.",
  Addcreditssuccessfully: "Add credits successfully",
  Cannotdeleteuser: "Can't delete user",
  CantCreateAPIkeymore: "Can't create API key",

  //login
  Getmorething: "Get more things done with sign in service",
  Donthaveaccount: "Dont have an account yet",
  Createhere: "Create here",
  CreateAccessService: "Create an account and access to the service",
  Alreadyaccount: "Already have an account yet",
  UsePersonalInformation: "Use personal information for billing info",
  ForgotPassword: "Forgot your password ?",
  EnterEmail:
    "Enter your email address that you used to register below and we'll send you a link to reset your password.",
  SendEmail: "Send email",
  ResetPassword: "Reset password",
  ResetYourPassword: "Reset your password",
  PasswordNotMatch: "Confirm password and new password not match",
  Password8: "Your password must be at least 8 characters",
  ResetPasswordSuccess: "Reset password successfully",
  CheckEmail: "Check your email address to reset password.",

  //limit usage
  Usage: "Usage",
  Setting: "Setting",
  DefineService: "Define Service",
  ServiceManage: "Service Manage",
  All: "All",
  AddmoreData: "Add more electronic data API",
  AddmoreMap: "Add more electronic map API",
  ElectronicDataAPI: "Electronic data API",
  ElectronicMapAPI: "Electronic map API",
  RemoveDialog: "Do you want to remove",
  RemoveelectronicdataAPI: "Remove electronic data API",
  RemoveelectronicmapAPI: "Remove electronic map API",
  Ownerlist: "Owner list",
  SelectOwner: "Select fiber - optic owner",
  NoService: "No service",
  Manageservicesuccess: "Manage service success",
  of: "of",
  Updatefiber: "Update fiber-obtic success",
  addservice: "Add service success",
  RemoveService: "Remove service successfully",
  RemoveServiceError: "Remove service error",
  Credits: "Credits",

  //Our Exclusive Service
  Exclusive_Service_Data_Service:
    "Basemap data service and electrical system data service",
  Exclusive_Service_Map_Service:
    "Basemap map service and electrical system map service",
  sendMailSuccess: "Send email success.",
  sendMailError: "Send email error.",
};
